export default __webpack_public_path__ + "static/media/locationIcon.5fa4f2c6.png";